import { Button } from "components/ui/button";

interface TerminationModalProps {
  regionalName: string;
  everActivated: boolean;
  onConfirm: () => void;
}

export function TerminationModal({
  regionalName,
  everActivated,
  onConfirm,
}: TerminationModalProps) {
  return (
    <div className="p-4" role="status" aria-live="polite">
      <p className="mb-6 text-sm text-gray-600">
        {everActivated ? (
          <>
            Sua substituição de <strong>{regionalName}</strong> terminou. As telas
            dele(a) saíram do seu menu e você volta a operar apenas como você
            mesmo(a).
          </>
        ) : (
          <>
            A substituição de <strong>{regionalName}</strong> que estava prevista
            para você foi encerrada. Seu acesso continua exatamente como está.
          </>
        )}
      </p>
      <div className="flex justify-end">
        <Button onClick={onConfirm}>Entendi</Button>
      </div>
    </div>
  );
}
